import { createSelector } from 'reselect';

const selectShipment = (state: any) => state.shipment;

export const selectShipmentCurrentItem = createSelector([selectShipment], (shipment) => shipment.current);

export const selectShipmentListItems = createSelector([selectShipment], (shipment) => shipment.list);

export const selectShipmentItemById = (itemId: any) =>
    createSelector(selectShipmentListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectShipmentQueryItems = createSelector([selectShipment], (shipment) => shipment.query);

export const selectShipmentCreatedItem = createSelector([selectShipment], (shipment) => shipment.create);

export const selectShipmentPrintItem = createSelector([selectShipment], (shipment) => shipment.print);

export const selectShipmentUpdatedItem = createSelector([selectShipment], (shipment) => shipment.update);

export const selectShipmentExportItem = createSelector([selectShipment], (shipment) => shipment.export);


export const selectShipmentReadItem = createSelector([selectShipment], (shipment) => shipment.read);

export const selectShipmentDeletedItem = createSelector([selectShipment], (shipment) => shipment.delete);

export const selectShipmentSearchedItems = createSelector([selectShipment], (shipment) => shipment.search);

export const selectShipmentItemsCount = createSelector([selectShipment], (shipment) => shipment.count);

export const selectShipmentItemsFilter = createSelector([selectShipment], (shipment) => shipment.filter);